// Hardgecodete Pixel-Art-Helfer für den Blocky-/Voxel-Look der Spiele.
// Alle Grafiken sind Eigenkreationen (keine kopierten Assets) und werden
// prozedural auf Canvas gezeichnet — nichts wird nachgeladen.

// Zeichnet ein Sprite aus einem String-Raster. "." = transparent,
// jedes andere Zeichen wird über die Palette auf eine Farbe gemappt.
export function drawSprite(ctx, rows, palette, x, y, scale) {
  for (let r = 0; r < rows.length; r++) {
    const row = rows[r];
    for (let c = 0; c < row.length; c++) {
      const ch = row[c];
      if (ch === ".") continue;
      const color = palette[ch];
      if (!color) continue;
      ctx.fillStyle = color;
      ctx.fillRect(x + c * scale, y + r * scale, scale, scale);
    }
  }
}

// Pixel-Münze (Eigenkreation). 10 Münzen = 1 gratis PDF-Download —
// wird in den Spielen eingesammelt und überall als Icon genutzt.
export const COIN_PALETTE = {
  o: "#a8842c", // Rand
  y: "#f2b632", // Gold
  h: "#ffe08a", // Glanz
  d: "#c4881f", // Prägung
  s: "#c98f1e", // Schatten
};
export const COIN_SPRITE = [
  "..oooo..",
  ".ohhyyo.",
  "ohyddyso",
  "ohyddyso",
  "oyyddyso",
  "oyyddyso",
  ".oyyyso.",
  "..oooo..",
];
// Zeichnet die Münze mit Kantenlänge size (Sprite ist 8x8 Pixel).
export function drawCoin(ctx, x, y, size) {
  drawSprite(ctx, COIN_SPRITE, COIN_PALETTE, x, y, size / 8);
}

// Deterministischer Pseudozufall (damit Texturen bei jedem Frame identisch sind).
export function seededRandom(seed) {
  let s = seed >>> 0;
  return function () {
    s = (s * 1664525 + 1013904223) >>> 0;
    return s / 4294967296;
  };
}

// Zeichnet einen texturierten Voxel-Block: Grundfarbe + gestreute hellere/
// dunklere Pixel + dunkle Kante unten/rechts, helle Kante oben/links.
export function drawTexturedBlock(ctx, x, y, w, h, base, light, dark, seed) {
  ctx.fillStyle = base;
  ctx.fillRect(x, y, w, h);
  const rnd = seededRandom(seed);
  const px = Math.max(2, Math.floor(w / 10));
  for (let i = 0; i < (w * h) / (px * px * 3); i++) {
    const rx = x + Math.floor((rnd() * w) / px) * px;
    const ry = y + Math.floor((rnd() * h) / px) * px;
    ctx.fillStyle = rnd() > 0.5 ? light : dark;
    ctx.globalAlpha = 0.35;
    ctx.fillRect(rx, ry, px, px);
    ctx.globalAlpha = 1;
  }
  const edge = Math.max(2, Math.floor(w / 16));
  ctx.fillStyle = light;
  ctx.globalAlpha = 0.4;
  ctx.fillRect(x, y, w, edge);
  ctx.fillRect(x, y, edge, h);
  ctx.fillStyle = dark;
  ctx.fillRect(x, y + h - edge, w, edge);
  ctx.fillRect(x + w - edge, y, edge, h);
  ctx.globalAlpha = 1;
}

// Schachbrett-Gras (zwei Grüntöne) als Spielfeld-Hintergrund.
export function drawGrassBoard(ctx, cols, rows, cell, c1 = "#5d9e3f", c2 = "#569539") {
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      ctx.fillStyle = (r + c) % 2 === 0 ? c1 : c2;
      ctx.fillRect(c * cell, r * cell, cell, cell);
    }
  }
}

// Pixel-Font-Overlay im Spiel: blockige, fette Zahlen/Texte.
export function drawBlockText(ctx, text, x, y, size, color = "#ffffff", outline = "#1f2410") {
  ctx.font = `bold ${size}px 'Courier New', monospace`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.lineWidth = Math.max(3, size / 8);
  ctx.strokeStyle = outline;
  ctx.strokeText(text, x, y);
  ctx.fillStyle = color;
  ctx.fillText(text, x, y);
}

// Skaliert ein Canvas scharf (Pixel-Look, kein Smoothing) auf DPR.
export function setupCanvas(canvas, logicalW, logicalH) {
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  canvas.width = logicalW * dpr;
  canvas.height = logicalH * dpr;
  const ctx = canvas.getContext("2d");
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  ctx.imageSmoothingEnabled = false;
  return ctx;
}
